export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f017012979bfa233a9d1b1826dd8f9e1aab57638b&name=fetchTypeahead!'